import theme from "@/styles/theme";
import LinkIcon from "@mui/icons-material/Link";
import { IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import EventDateTime from "./EventDateTime";

export default function EventDateTimeLink({ event }) {
  return (
    <Grid
      container
      spacing={1}
      alignItems="center"
      sx={eventDateTimeLinkStyles}
    >
      <Grid
        item
        xs={event.link ? 10.2 : 12}
        sm={event.link ? 10.9 : 12}
        lg={event.link ? 10.9 : 12}
        xl={event.link ? 11.2 : 12}
      >
        <EventDateTime event={event} />
      </Grid>
      {event.link && (
        <Grid item xs="auto">
          <IconButton
            href={event.link}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            className="event-link-icon"
          >
            <LinkIcon fontSize="small" />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
}

const eventDateTimeLinkStyles = {
  "& .event-link-icon": {
    color: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}4A`,
    borderRadius: "0.25rem",
    transition: "background-color 0.3s ease-in-out, color 0.3s ease-in-out",
    "&:hover": {
      background: `${theme.palette.primary.main}`,
      color: "white",
      borderColor: `${theme.palette.primary.main}`,
    },
  },
};
